import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

export type BalanceProviderFormGroup = FormGroup<{
    balanceProviderId: FormControl<string | null>,
    accessToken: FormControl<string | null>,
    environmentId: FormControl<string | null>,
    administrationId: FormControl<string | null>
}>;

export function createBalanceProviderFormGroup(formBuilder: FormBuilder): BalanceProviderFormGroup {
    return formBuilder.group({
        balanceProviderId: new FormControl<string | null>(null),
        accessToken: new FormControl<string | null>(null, {
            nonNullable: false,
            validators: [Validators.required, Validators.pattern(/\S+/)],
        }),
        environmentId: new FormControl<string | null>(null),
        administrationId: new FormControl<string | null>(null),
    });
}
